
/**
 * Image Modal - Zeigt Fotos als Layer an
 */

class ImageModal {
  constructor() {
    this.modal = document.getElementById('imageModal');
    this.modalImage = document.getElementById('modalImage');
    this.closeBtn = document.querySelector('.modal-close');
    this.init();
  }

  init() {
    if (!this.modal) return;

    // Event-Listener für alle Links mit data-image-modal Attribut
    document.addEventListener('click', (e) => {
      if (e.target.closest('a[data-image-modal]')) {
        e.preventDefault();
        const imageUrl = e.target.closest('a[data-image-modal]').getAttribute('href');
        this.openModal(imageUrl);
      }
    });

    // Schließen-Button
    this.closeBtn?.addEventListener('click', () => this.closeModal());

    // Schließen beim Klick auf den Hintergrund
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    // Schließen mit Escape-Taste
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeModal();
      }
    });
  }

  openModal(imageUrl) {
    this.modalImage.src = imageUrl;
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Verhindert Scrolling
  }

  closeModal() {
    this.modal.classList.remove('active');
    document.body.style.overflow = 'auto';
  }
}

// Initialisieren wenn DOM geladen ist
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ImageModal();
  });
} else {
  new ImageModal();
}
